// extracted by mini-css-extract-plugin
export default {"ellipsis":"G3JPE7xZXvueumwB-iJvJw==","ellipsis1":"hcygmhFwWdpw2lAfxvYmsw==","ellipsis2":"uvLkAEECqpibox63zpHQUQ==","ellipsis3":"iuZYfmFQePkhUshmD5x4FQ=="};